// Website Creator: htutkhaung.ko@msgtech.co.th
/**
 * MSGTech Comprehensive Bilingual Localization Dictionary
 * Default Language: Thai ('th')
 * Secondary Language: English ('en')
 */

export const TRANSLATIONS = {
  th: {
    // ─── Header & Navigation ───
    'nav.solutions': 'โซลูชันทั้งหมด',
    'nav.mala_pos': 'ระบบเครื่องชั่งหมาล่า',
    'nav.hardware': 'ฮาร์ดแวร์ POS & คีออส',
    'nav.leadership': 'ทีมผู้บริหาร',
    'nav.contact': 'ติดต่อเรา',
    'nav.book_consultation': 'จองปรึกษาฟรี',
    'nav.lang_toggle_label': 'ภาษา / Language: ไทย (TH)',
    'nav.lang_display': 'TH',

    // ─── Hero Section ───
    'hero.badge': 'เทคโนโลยีชั้นนำสำหรับธุรกิจบริการและองค์กรในไทย',
    'hero.title': 'ยกระดับธุรกิจบริการและร้านอาหาร ด้วยระบบอัจฉริยะแบบครบวงจร',
    'hero.desc': 'วิศวกรรมเทคโนโลยีระดับองค์กรสำหรับร้านอาหารยอดนิยม รีสอร์ทหรูระดับ 5 ดาว และธุรกิจชั้นนำ สำนักงานใหญ่ตั้งอยู่ ณ เกาะสมุย ให้บริการครอบคลุมเกาะพะงัน สุราษฎร์ธานี กรุงเทพฯ และทั่วประเทศไทย',
    'hero.btn_solutions': 'สำรวจโซลูชันทั้งหมด',
    'hero.btn_mala_sim': 'ทดสอบเครื่องชั่งหมาล่าจำลอง',
    'hero.stat_latency_val': 'ต่ำกว่า 10ms',
    'hero.stat_latency_label': 'ความเร็วสตรีมน้ำหนัก POS',
    'hero.stat_uptime_val': '99.98%',
    'hero.stat_uptime_label': 'มาตรฐานความเสถียรระบบ (SLA)',
    'hero.stat_terminals_val': '150+',
    'hero.stat_terminals_label': 'จุดติดตั้งที่ใช้งานจริง',
    'hero.stat_margin_val': '0%',
    'hero.stat_margin_label': 'ข้อผิดพลาดการชั่งน้ำหนัก',

    // ─── Architecture & Deconstruct ───
    'arch.subtitle': 'สถาปัตยกรรมระบบรวมศูนย์ระดับองค์กร',
    'arch.title': 'ออกแบบเพื่อความเร็วระดับมิลลิวินาที และตัดปัญหาสินค้าสูญหาย 100%',
    'arch.desc': 'เปรียบเทียบข้อจำกัดของระบบ POS ทั่วไปที่ทำให้ธุรกิจสูญเสียรายได้ กับสถาปัตยกรรมแบบรวมศูนย์ของ MSGTech',
    'arch.tab_comparison': 'เปรียบเทียบสองระบบ',
    'arch.tab_legacy': 'วิเคราะห์ระบบ POS แบบเดิม',
    'arch.tab_msgtech': 'สถาปัตยกรรมรวมศูนย์ MSGTech',

    'arch.legacy_badge': 'ระบบแบบเดิมที่แยกส่วน',
    'arch.legacy_title': 'ฮาร์ดแวร์ไม่เชื่อมโยง คอขวดจากการคีย์ข้อมูลด้วยมือ',
    'arch.legacy_desc': 'ระบบ POS ทั่วไปในร้านบุฟเฟต์หรือหมาล่า ต้องอาศัยพนักงานจดหรือคีย์น้ำหนักจากตาชั่งลงหน้าจอด้วยมือ ทำให้เกิดความผิดพลาด แถวสะสมช้า และเสี่ยงต่อการทุจริต',
    'arch.legacy_p1': 'พนักงานต้องกรอกน้ำหนักด้วยตนเอง เสี่ยงผิดพลาดและคิดเงินช้า',
    'arch.legacy_p2': 'เครื่องพิมพ์ใบเสร็จและหน้าจอแยกส่วน ทำงานสะดุดในช่วงเวลาเร่งด่วน',
    'arch.legacy_p3': 'ระบบสต็อกไม่ตัดเรียลไทม์ ทำให้สินค้าสูญหาย (Shrinkage) สูงถึง 8-12%',
    'arch.legacy_p4': 'ระบบคลาวด์หลุดบ่อย ไม่รองรับการทำงานออฟไลน์ (Offline-First)',
    'arch.legacy_tag1': 'คีย์น้ำหนักด้วยมือ',
    'arch.legacy_tag2': 'คิวชำระเงินล่าช้า',
    'arch.legacy_tag3': 'สต็อกไม่ตรง',
    'arch.legacy_tag4': 'สูญเสียรายได้',

    'arch.unified_badge': 'สถาปัตยกรรมรวมศูนย์ MSGTech',
    'arch.unified_title': 'เชื่อมต่อตาชั่ง POS และครัว แบบดิจิทัลระดับมิลลิวินาที',
    'arch.unified_desc': 'โครงสร้างแบบไร้รอยต่อ: สตรีมน้ำหนักดิจิทัลผ่านพอร์ต RS-232 หักลบน้ำหนักภาชนะอัตโนมัติ คำนวณราคาแม่นยำ พร้อมสร้าง PromptPay QR ทันทีในเวลาต่ำกว่า 8 วินาทีต่อออเดอร์',
    'arch.unified_p1': 'ดึงน้ำหนักจากตาชั่งดิจิทัลทันที แม่นยำ 100% ปราศจากมนุษย์แทรกแซง',
    'arch.unified_p2': 'หักน้ำหนักชาม (Tare) อัตโนมัติ พร้อมตรวจจับความนิ่งของเซ็นเซอร์',
    'arch.unified_p3': 'สร้าง Dynamic PromptPay QR และพิมพ์สลิป KDS ไปยังครัวทันที',
    'arch.unified_p4': 'ทำงานแบบ Offline-First ข้อมูลไม่สูญหายแม้สัญญาณอินเทอร์เน็ตขัดข้อง',
    'arch.unified_tag1': 'สตรีมมิ่ง RS-232',
    'arch.unified_tag2': 'หักน้ำหนักชามอัตโนมัติ',
    'arch.unified_tag3': 'ออกบิลใน 8 วินาที',
    'arch.unified_tag4': 'ความแม่นยำ 100%',

    // ─── Mala Scale POS Simulator ───
    'mala.subtitle': 'ระบบจำลองการทำงานแบบอินเทอร์แอคทีฟ',
    'mala.title': 'ทดลองใช้งานเครื่องชั่งและระบบคิดเงินหมาล่ายอดนิยม',
    'mala.desc': 'เลื่อนหน้าจอลงเพื่อดูการทำงานจำลอง: วางชาม วัตถุดิบลงตาชั่ง เซ็นเซอร์อ่านค่าน้ำหนัก และระบบ POS คำนวณราคาแบบเรียลไทม์',
    
    'mala.step0_btn': '🥣 1. หักน้ำหนักชาม (0.0g)',
    'mala.step1_btn': '🥩 2. +เนื้อแองกัส (+140g)',
    'mala.step2_btn': '🥬 3. +เห็ดเข็มทองและรากบัว (+110g)',
    'mala.step3_btn': '🍢 4. +ลูกชิ้นและเต้าหู้ (+125g)',
    'mala.step4_btn': '💳 5. ล็อกน้ำหนัก & สร้าง QR',
    'mala.autoplay_start': '▶ เล่นตัวอย่างอัตโนมัติ',
    'mala.autoplay_pause': '⏸ หยุดชั่วคราว',

    'mala.console_title': '⚖️ หน้าต่างแสดงค่าน้ำหนักดิจิทัล',
    'mala.console_baud': 'RS-232 พอร์ต COM2 • 9600 BAUD • อัปเดตทุก 10ms',
    'mala.status_streaming': '● กำลังสตรีมข้อมูล (10ms)',
    'mala.status_stabilized': '● น้ำหนักนิ่งแล้ว (LOCKED)',
    'mala.live_net_weight': 'น้ำหนักสุทธิ (NET WEIGHT)',
    'mala.gross_label': 'น้ำหนักรวม:',
    'mala.tare_label': 'หักชาม:',
    'mala.net_label': 'สุทธิ:',

    'mala.platter_label': 'ถาดชั่งมาตรฐานรับรองความเที่ยงตรง MSGTECH',
    'mala.bowl_title': '🥣 ชามใส่วัตถุดิบหมาล่า',
    'mala.bowl_empty_title': '🥣 ชามพร้อมวางวัตถุดิบ',
    'mala.bowl_empty_sub': 'หักน้ำหนักชามแล้ว (-120.0g) • รอเพิ่มวัตถุดิบ',

    'mala.slider_label': 'แถบเลื่อนปรับน้ำหนักทดสอบ',
    'mala.slider_range': '120g – 950g',
    'mala.tray_header': 'หรือแตะเลือกวัตถุดิบเพื่อทดสอบ:',
    'mala.tray_beef': '🥩 เนื้อแองกัส (+140g)',
    'mala.tray_veg': '🥬 เห็ดเข็มทอง & รากบัว (+110g)',
    'mala.tray_balls': '🍢 เต้าหู้ปลา & ลูกชิ้น (+125g)',
    'mala.tray_mushroom': '🍄 เห็ดหอมรวม (+75g)',

    'mala.broth_header': 'เลือกซุปหมาล่า & ระดับความเผ็ด:',
    'mala.broth_dry': '🔥 ผัดหมาล่าแห้ง (เผ็ดกลาง)',
    'mala.broth_soup': '🌶️ ซุปหมาล่าเสฉวน (เผ็ดชามาก)',
    'mala.broth_bone': '🍲 ซุปกระดูกคอลลาเจน (ไม่เผ็ด)',
    'mala.broth_tomato': '🍅 ซุปมะเขือเทศสมุนไพร (กลมกล่อม)',

    'mala.customer_screen_badge': 'หน้าจอสำหรับลูกค้า (Customer Mirror)',
    'mala.order_total_label': 'ยอดรวมทั้งสิ้น',
    'mala.cust_net_label': 'น้ำหนักสุทธิ:',
    'mala.cust_rate_label': 'ราคาต่อ 100 กรัม:',
    'mala.cust_broth_label': 'รสชาติซุปที่เลือก:',

    'mala.qr_awaiting_title': 'กำลังรอน้ำหนักนิ่ง...',
    'mala.qr_awaiting_sub': 'ใส่วัตถุดิบเพื่อสร้าง PromptPay QR อัตโนมัติ',
    'mala.qr_active_title': '✓ พร้อมสแกน Thai PromptPay QR',
    'mala.qr_active_sub': 'สแกนจ่ายผ่านแอปพลิเคชันธนาคารไทยได้ทุกธนาคาร ยอดชำระ',

    'mala.ticket_shop': 'MSGTECH MALA HOTPOT KITCHEN',
    'mala.ticket_table': 'ออเดอร์ #M108 • โต๊ะ 14',
    'mala.ticket_item': 'ชามหมาล่าเลือกตักเอง',
    'mala.ticket_total': 'ยอดชำระสุทธิ',
    'mala.ticket_kds': 'บาร์โค้ดส่งครัว KDS: ML-8924108',

    // ─── Solutions Suite ───
    'solutions.subtitle': 'ปรับแต่งตามความต้องการเฉพาะของธุรกิจ',
    'solutions.title': 'เทคโนโลยีและระบบปฏิบัติการระดับองค์กร',
    'solutions.desc': 'ระบบที่เสถียร เชื่อถือได้ ออกแบบมาเพื่อลดขั้นตอนการทำงาน สร้างความประทับใจให้ลูกค้า และเพิ่มผลกำไรให้ธุรกิจคุณ',
    'solutions.tab_all': 'โซลูชันทั้งหมด',
    'solutions.tab_enterprise': 'ระบบองค์กรและ ERP',
    'solutions.tab_hotel': 'โรงแรมและสปา',
    'solutions.tab_pos': 'ระบบ POS & คีออส',
    'solutions.tab_infra': 'เครือข่ายและความปลอดภัย',
    'solutions.tab_custom': 'พัฒนาซอฟต์แวร์เฉพาะทาง',

    // ─── Hardware Showcase ───
    'hardware.subtitle': 'ฮาร์ดแวร์เกรดอุตสาหกรรมสำหรับธุรกิจ',
    'hardware.title': 'ทนทาน รองรับงานหนัก ไม่สะดุดในทุกสภาพแวดล้อม',
    'hardware.desc': 'อุปกรณ์ POS หน้าจอคู่ความสว่างสูง คีออสสั่งอาหารอัตโนมัติ ตาชั่งกันน้ำ และกลอนประตูดิจิทัล ทนทานต่อสภาพอากาศชายทะเลและความชื้นสูงบนเกาะ',
    'hardware.pos_title': 'เครื่องแคชเชียร์ POS หน้าจอคู่เกรดพรีเมียม',
    'hardware.pos_desc': 'หน้าจอหลักระบบสัมผัส Capacitive 15.6 นิ้ว พร้อมหน้าจอด้านหลังสำหรับลูกค้า แสดงราคาสดและ Thai QR Pay ตัวเครื่องอะลูมิเนียมระบายความร้อน ไร้พัดลม',
    'hardware.kiosk_title': 'ตู้คีออสสั่งอาหารและบริการตัวเอง (21.5" & 27")',
    'hardware.kiosk_desc': 'ตู้สั่งอาหารอัตโนมัติหน้าจอสัมผัสขนาดใหญ่ เครื่องสแกนบาร์โค้ด/QR ความเร็วสูง เครื่องพิมพ์สลิปเทอร์มอล 80 มม. ตัดกระดาษอัตโนมัติ และไฟ LED แสดงสถานะ',
    'hardware.scale_title': 'ชุดตาชั่งดิจิทัลรับรองมาตรฐานการค้า',
    'hardware.scale_desc': 'ถาดสแตนเลส SUS304 ป้องกันน้ำและสารเคมี เซ็นเซอร์โหลดเซลล์ความแม่นยำสูง เชื่อมต่อผ่านพอร์ต RS-232/USB โดยตรงไปยังระบบ POS โดยไม่ต้องคีย์มือ',
    'hardware.locks_title': 'กลอนประตูดิจิทัลโรงแรม Bluetooth & RFID',
    'hardware.locks_desc': 'ตัวเรือนสแตนเลสสตีลทนไอทะเล รองรับคีย์การ์ด RFID บัตร Mifare และเปิดผ่านสมาร์ทโฟน Sync ตรงกับระบบบริหารจัดการโรงแรม (PMS)',
    'hardware.printer_title': 'เครื่องพิมพ์ใบเสร็จเทอร์มอลความเร็วสูง 260mm/s',
    'hardware.printer_desc': 'เครื่องพิมพ์ออเดอร์ในครัวและเคาน์เตอร์แคชเชียร์ รองรับพอร์ต LAN, USB, Serial พร้อมเสียงแจ้งเตือนออเดอร์เข้าในครัวที่เสียงดัง',
    'hardware.wifi_title': 'ระบบโครงข่ายไฟเบอร์และ Enterprise Wi-Fi 7',
    'hardware.wifi_desc': 'จุดกระจายสัญญาณ Wi-Fi ความหนาแน่นสูง สวิตช์ PoE แบบ Managed และตู้แร็คเซิร์ฟเวอร์ ออกแบบรองรับผู้ใช้นับพันคนพร้อมกันอย่างไร้รอยต่อ',

    // ─── Leadership & Local Team ───
    'leadership.subtitle': 'ก่อตั้งบนเกาะสมุย ไว้วางใจได้ทั่วประเทศ',
    'leadership.title': 'ทีมผู้นำและวิศวกรผู้เชี่ยวชาญ',
    'leadership.desc': 'มีสำนักงานใหญ่บนเกาะสมุย พร้อมทีมวิศวกรและช่างเทคนิคในพื้นที่เกาะพะงัน สุราษฎร์ธานี กรุงเทพฯ และเชียงใหม่ ตอบสนองฉับไวตลอด 24/7',
    'leadership.nick_role': 'ผู้ก่อตั้ง & หัวหน้าสถาปนิกเทคโนโลยี (Founder & Chief Architect)',
    'leadership.nick_bio': 'ผู้เชี่ยวชาญด้านการออกแบบสถาปัตยกรรมระบบคลาวด์และฮาร์ดแวร์ไอทีระดับองค์กร นำประสบการณ์ด้านวิศวกรรมซอฟต์แวร์ระดับสากลมาพัฒนาระบบเทคโนโลยีสำหรับธุรกิจบริการ ร้านอาหาร และโรงแรมหรูในเกาะสมุยและประเทศไทย',
    'leadership.co_role': 'ทีมวิศวกรรมซอฟต์แวร์และโครงข่ายระดับสูง',
    'leadership.co_desc': 'ทีมงานมืออาชีพที่มีความเชี่ยวชาญเฉพาะทาง ทั้งด้านฮาร์ดแวร์ IoT เครือข่ายไฟเบอร์ออปติก และการเชื่อมโยงระบบฐานข้อมูล ERP/PMS',
    
    'leadership.pillar1_title': 'เข้าดูแลหน้างานภายใน 2 ชม.',
    'leadership.pillar1_desc': 'ทีมวิศวกรประจำการบนเกาะสมุยและพะงัน เข้าแก้ไขปัญหาฉุกเฉินได้อย่างรวดเร็ว ไม่ต้องรอช่างจากกรุงเทพฯ',
    'leadership.pillar2_title': 'ฮาร์ดแวร์ทนทานต่อสภาพอากาศทะเล',
    'leadership.pillar2_desc': 'อุปกรณ์ทุกชิ้นผ่านการคัดสรรและเคลือบป้องกันความชื้น ไอเค็มทะเล และไฟกระชาก เพื่อการทำงานที่ต่อเนื่อง 24 ชม.',
    'leadership.pillar3_title': 'ปรึกษาทีมสถาปนิกและนักพัฒนาโดยตรง',
    'leadership.pillar3_desc': 'คุยตรงกับผู้พัฒนาระบบ ไม่ผ่านเซลส์คนกลาง เข้าใจความต้องการทางเทคนิคและปรับแต่งฟังก์ชันได้ตามโจทย์จริง',
    'leadership.pillar4_title': 'ออกแบบพิมพ์เขียวระบบ ฟรีไม่มีค่าใช้จ่าย',
    'leadership.pillar4_desc': 'บริการสำรวจหน้างานและเขียนแบบสถาปัตยกรรมเทคโนโลยีเบื้องต้นให้ธุรกิจคุณฟรี เพื่อความชัดเจนก่อนเริ่มงาน',

    // ─── Contact & Modal ───
    'modal.title': 'นัดหมายปรึกษาผู้เชี่ยวชาญ',
    'modal.desc': 'พูดคุยโดยตรงกับผู้บริหารและสถาปนิกโซลูชันของ MSGTech ครบวงจรตั้งแต่ฮาร์ดแวร์จนถึงซอฟต์แวร์ — หากคุณคิดได้ เราทำได้จริง',
    'modal.name_label': 'ชื่อ-นามสกุล / ชื่อบริษัทหรือองค์กรของคุณ',
    'modal.name_placeholder': 'เช่น John Doe, Muang Samui Wellness Resort',
    'modal.email_label': 'อีเมลสำหรับติดต่อธุรกิจ',
    'modal.email_placeholder': 'เช่น contact@yourbusiness.com หรือ nick@msgtech.co.th',
    'modal.service_label': 'โซลูชันหรือเทคโนโลยีที่ท่านสนใจ',
    'modal.service_default': '-- กรุณาเลือกโซลูชันที่ต้องการ --',
    'modal.service_general': 'ปรึกษาภาพรวมระบบเทคโนโลยี (General Consultation)',
    'modal.service_mala': 'ระบบเครื่องชั่งหมาล่า (Trade-Scale Integrated Mala POS)',
    'modal.service_pos': 'ระบบแคชเชียร์และตู้คีออส (Cashier POS & Self-Checkout Kiosks)',
    'modal.service_erp': 'ระบบบัญชีและการเงิน ERP (Enterprise ERP & Accounting)',
    'modal.service_inventory': 'ระบบสต็อกและคลังสินค้า (Smart Inventory & Warehouse)',
    'modal.service_hotel': 'ระบบโรงแรมอัจฉริยะและกลอนประตู (Smart Hotel IoT & Locks)',
    'modal.service_spa': 'ระบบบริหารสปาและทรีตเมนต์ (Spa & Wellness POS/Booking)',
    'modal.service_channel': 'ระบบจัดการห้องพัก OTA (Channel Manager & Direct Booking)',
    'modal.service_wifi': 'โครงข่ายอินเทอร์เน็ตและ Wi-Fi (Enterprise Wi-Fi & Fiber)',
    'modal.service_cctv': 'กล้องวงจรปิด AI และความปลอดภัย (AI CCTV & Access Control)',
    'modal.service_custom': 'พัฒนาแอปและวิศวกรรมเฉพาะทาง (Custom Engineering)',
    
    'modal.scope_label': 'แตะเลือกแท็กขอบเขตงานที่ต้องการ:',
    'modal.chip_erp': 'ระบบ ERP องค์กร',
    'modal.chip_inventory': 'ระบบคลังสินค้าอัจฉริยะ',
    'modal.chip_hr': 'ระบบคิดเงินเดือน & HR',
    'modal.chip_hotel_locks': 'กลอนประตูดิจิทัลโรงแรม',
    'modal.chip_spa': 'ระบบจองคอร์สสปา',
    'modal.chip_mala': 'เครื่องชั่งคิดเงินหมาล่า',
    'modal.chip_pos': 'เครื่อง POS แคชเชียร์',
    'modal.chip_kiosk': 'ตู้คีออสบริการตัวเอง',
    'modal.chip_wifi': 'เครือข่าย Wi-Fi องค์กร',
    'modal.chip_cctv': 'กล้องวงจรปิด AI & ความปลอดภัย',
    'modal.chip_app': 'พัฒนาแอปพลิเคชันมือถือ',
    'modal.chip_hardware': 'ออกแบบฮาร์ดแวร์เฉพาะทาง',
    'modal.msg_label': 'รายละเอียดโครงการ & ความต้องการเพิ่มเติม',
    'modal.msg_placeholder': 'บอกเล่าเกี่ยวกับธุรกิจ จำนวนสาขา กรอบระยะเวลา หรือฟังก์ชันที่ต้องการเป็นพิเศษ...',
    'modal.submit_btn': 'ส่งคำขอนัดหมายถึงทีมงาน MSGTech',
    'modal.success_title': '✓ เปิดร่างอีเมลติดต่อทีมงานแล้ว',
    'modal.success_sub': 'ระบบได้จัดเตรียมเนื้อหาเพื่อส่งถึง info@msgtech.co.th เรียบร้อยแล้ว ทีมงานจะติดต่อกลับภายใน 24 ชั่วโมง',

    // ─── Footer ───
    'footer.company_desc': 'ผู้ให้บริการเทคโนโลยีและระบบสารสนเทศชั้นนำสำหรับธุรกิจบริการ โรงแรมหรู และร้านอาหาร สำนักงานใหญ่เกาะสมุย ให้บริการทั่วไทย',
    'footer.col_solutions': 'โซลูชันหลัก',
    'footer.col_company': 'เกี่ยวกับเรา',
    'footer.col_regions': 'พื้นที่ให้บริการ',
    'footer.col_contact': 'ข้อมูลการติดต่อ',
    'footer.col_inquiries': 'ติดต่อสอบถาม',
    'footer.inquiries_sub': 'พูดคุยกับทีมผู้บริหารโดยตรงสำหรับข้อเสนอทางธุรกิจและระบบโรงแรม',
    'footer.reg_samui': 'เกาะสมุย (สำนักงานใหญ่)',
    'footer.reg_phangan': 'เกาะพะงัน',
    'footer.reg_surat': 'สุราษฎร์ธานี',
    'footer.reg_bkk': 'กรุงเทพมหานคร',
    'footer.reg_cm': 'เชียงใหม่และทั่วประเทศ',
    'footer.address_val': '13/1 หมู่ 1 ต.บ่อผุด อ.เกาะสมุย จ.สุราษฎร์ธานี 84320',
    'footer.phone_val': '081-894-5556',
    'footer.email_val': 'info@msgtech.co.th',
    'footer.rights': '© 2026 บริษัท เอ็มเอสจีเทค จำกัด สงวนลิขสิทธิ์ทุกประการ',
    'footer.bottom_loc': 'เกาะสมุย, สุราษฎร์ธานี, ประเทศไทย • เทคโนโลยีธุรกิจบริการ & ระบบแคชเชียร์ POS',
    'footer.certified': 'ฮาร์ดแวร์และเครื่องชั่งได้รับการรับรองตามมาตรฐานการค้าและกรมการค้าภายในประเทศไทย',

    // ─── Mala POS Deconstruct & Benchmark Extra ───
    'arch.benchmark': '🍜 มาตรฐานวิศวกรรมสำหรับธุรกิจร้านอาหารยอดนิยม',
    'arch.section_title': 'ถอดรหัสระบบ POS แบบดั้งเดิม & สร้างใหม่สำหรับร้านหมาล่า',
    'arch.section_desc': 'ร้านหมาล่าทั่งและชาบูหม้อไฟต้องเผชิญกับคอขวดสำคัญ: ราคาขึ้นอยู่กับน้ำหนักในชาม ระบบ POS ทั่วไปบีบให้แคชเชียร์ต้องคอยเพ่งตาชั่ง กรอกตัวเลขด้วยมือ และอ่านลายมือจดสลิป นี่คือวิธีที่ MSGTech แยกแยะปัญหาและสร้างสถาปัตยกรรมใหม่ด้วยเครื่องชั่งรับรองมาตรฐานการค้า',
    'arch.toggle_comparison': 'เปรียบเทียบสถาปัตยกรรมระบบ',
    'arch.toggle_deconstruct': 'จุดบกพร่องของระบบเดิม (4 ข้อ)',
    'arch.toggle_reconstruct': 'สถาปัตยกรรมรวมศูนย์ MSGTech',
    'arch.legacy_badge_flaw': '⚠️ วิเคราะห์จุดบกพร่อง: ระบบ POS ทั่วไป',
    'arch.legacy_tag_time': 'คอขวด 45–60 วินาทีต่อลูกค้า',
    'arch.legacy_h3': 'ทำไมระบบ POS ปกติจึงใช้ไม่ได้ผลในร้านหมาล่า',
    'arch.legacy_sub': 'ระบบ POS มาตรฐานถือว่าน้ำหนักเป็นเรื่องรอง ทำให้เกิดความผิดพลาดจากคนและสินค้าสูญหายมหาศาล',
    'arch.flaw1_title': 'เครื่องชั่งแยกส่วนไม่เชื่อมต่อ:',
    'arch.flaw1_desc': 'เครื่องชั่งเป็นหน่วยแยกอิสระไม่มีสายเชื่อมโยงไปยัง POS แคชเชียร์ต้องคอยเพ่งตัวเลข LED',
    'arch.flaw2_title': 'คีย์น้ำหนักด้วยมือบนหน้าจอ:',
    'arch.flaw2_desc': 'แคชเชียร์กรอกน้ำหนักด้วยมือ เสี่ยงพิมพ์ผิด ทุจริต และทำให้คิวล่าช้าสะสม',
    'arch.flaw3_title': 'หักน้ำหนักชามไม่คงที่:',
    'arch.flaw3_desc': 'น้ำหนักชามแต่ละประเภทแตกต่างกัน พนักงานมักลืมกดหักน้ำหนัก เกิดข้อพิพาทกับลูกค้า',
    'arch.flaw4_title': 'จดกระดาษและออเดอร์สับสน:',
    'arch.flaw4_desc': 'ระดับความเผ็ดและซุปเขียนบนกระดาษ ครัวอ่านไม่ออก ทำอาหารผิด ต้องทำใหม่',

    'arch.recon_badge': '✨ สร้างใหม่: MSGTech Trade-Scale POS',
    'arch.recon_speed': 'ความเร็วชำระเงิน < 8 วินาที',
    'arch.recon_h3': 'เชื่อมตาชั่งดิจิทัล + หน้าจอคู่สำหรับลูกค้า',
    'arch.recon_sub': 'สถาปัตยกรรมฮาร์ดแวร์-ซอฟต์แวร์รวมศูนย์ ดึงน้ำหนักในระดับมิลลิวินาที หักน้ำหนักชามอัตโนมัติ และสร้าง PromptPay QR ทันที',
    'arch.recon1_title': 'โพรโทคอล RS-232 / USB มาตรฐานการค้า:',
    'arch.recon1_desc': 'ตาชั่งส่งข้อมูลน้ำหนักดิจิทัลตรงเข้าสู่แอป POS ทุกๆ 10ms ปราศจากการกรอกด้วยมือ',
    'arch.recon2_title': 'หักน้ำหนักชามอัจฉริยะอัตโนมัติ:',
    'arch.recon2_desc': 'วางชามบนแท่นชั่ง ระบบหักน้ำหนักชามทันที (-120.0g) คิดเงินเฉพาะน้ำหนักอาหารแท้จริง',
    'arch.recon3_title': 'หน้าจอแสดงราคาสดสำหรับลูกค้า:',
    'arch.recon3_desc': 'หน้าจอด้านหลังแสดงน้ำหนัก ราคาต่อ 100g และราคารวมแบบเรียลไทม์ทันทีที่วางของ',
    'arch.recon4_title': 'เลือกซุปใน 1 แตะ & ออกบาร์โค้ดครัว:',
    'arch.recon4_desc': 'แตะเลือกซุปเพียง 1 ครั้ง สร้าง Thai PromptPay QR ในเวลาไม่ถึง 1 วินาที พร้อมพิมพ์บาร์โค้ดส่งครัว KDS ทันที',

    // ─── Mala Simulator Workbench Extra ───
    'mala.testbench_badge': 'ระบบทดสอบแบบอินเทอร์แอคทีฟ',
    'mala.testbench_title': 'ระบบจำลองเครื่องชั่งและ POS หมาล่า',
    'mala.testbench_desc': 'ปรับน้ำหนักบนถาด สลับการหักน้ำหนัก เลือกรสชาติซุป และชมการตอบสนองของหน้าจอ POS คู่และเครื่องพิมพ์ครัวแบบสดๆ',
    'mala.tare_badge': 'หักชาม: อัตโนมัติ (-120g)',
    'mala.btn_zero_tare': 'รีเซ็ตหักชาม (Calibrate)',
    'mala.step_init_text': 'ขั้นตอน 1/5: วางชามเปล่า & หักน้ำหนักชามอัตโนมัติ (-120.0g)',
    'mala.sys_listening_title': 'ระบบกำลังรับสัญญาณจากเครื่องชั่ง...',
    'mala.sys_listening_desc': 'เลื่อนหน้าจอลงเพื่อวางวัตถุดิบลงตาชั่ง ระบบจะรับรู้น้ำหนักและคำนวณใหม่แบบเรียลไทม์',

    // ─── Hardware Extra ───
    'hardware.section_subtitle': 'ฮาร์ดแวร์และระบบอุปกรณ์',
    'hardware.section_title': 'เครื่องแคชเชียร์ POS & ตู้คีออสบริการตัวเอง',
    'hardware.section_desc': 'เครื่อง POS แคชเชียร์เกรดพานิชย์ ตู้สั่งอาหารอัตโนมัติ และอุปกรณ์ต่อพ่วงสำหรับธุรกิจบริการ พร้อมระบบชำระเงิน Thai QR / PromptPay และบัตรเครดิต',
    'hardware.badge_cashier': 'เคาน์เตอร์แคชเชียร์',
    'hardware.card1_title': 'เครื่อง POS แคชเชียร์',
    'hardware.card1_desc': 'เครื่อง POS หน้าจอสัมผัสคู่ ตอบสนองฉับไว พร้อมหน้าจอด้านหลังสำหรับลูกค้า เครื่องพิมพ์ใบเสร็จเทอร์มอลในตัว และระบบเปิดลิ้นชักเก็บเงินอัตโนมัติ',
    'hardware.card1_tag1': 'หน้าจอสัมผัสคู่',
    'hardware.card1_tag2': 'พิมพ์ใบเสร็จความเร็วสูง',
    'hardware.card1_tag3': 'รองรับ PromptPay QR',

    'hardware.badge_kiosk': 'สั่งอาหารด้วยตัวเอง',
    'hardware.card2_title': 'ตู้คีออสสั่งอาหารอัตโนมัติ',
    'hardware.card2_desc': 'ตู้สั่งอาหารและชำระเงินอัตโนมัติแบบตั้งพื้นและตั้งโต๊ะ ดีไซน์ทันสมัย สำหรับโรงแรม ร้านอาหารจานด่วน พร้อมสแกนเนอร์บาร์โค้ดและการชำระเงินไร้เงินสด',
    'hardware.card2_tag1': 'สั่งอาหารด้วยตนเอง',
    'hardware.card2_tag2': 'เครื่องสแกนบาร์โค้ด',
    'hardware.card2_tag3': 'บัตรเครดิต & QR โค้ด',

    'hardware.badge_peripherals': 'อุปกรณ์เชื่อมต่อครบวงจร',
    'hardware.card3_title': 'อุปกรณ์ต่อพ่วงสำหรับร้านอาหารและโรงแรม',
    'hardware.card3_desc': 'เชื่อมต่ออุปกรณ์ที่ผ่านการรับรองมาตรฐาน: เครื่องชั่งน้ำหนัก หน้าจอ KDS ในครัว กลอนประตูดิจิทัล RFID และเซ็นเซอร์ตรวจวัดอัจฉริยะ',
    'hardware.card3_tag1': 'เครื่องชั่งมาตรฐานการค้า',
    'hardware.card3_tag2': 'จอ KDS ในครัว',
    'hardware.card3_tag3': 'คีย์การ์ด RFID',

    // ─── Leadership Section ───
    'about.subtitle': 'ทีมผู้บริหารของเรา',
    'about.title': 'ผู้นำที่มุ่งมั่นและเปี่ยมประสบการณ์',
    'about.desc': 'ขับเคลื่อนด้วยวิสัยทัศน์ในตลาดธุรกิจบริการของไทย ผสานกับความเชี่ยวชาญด้านสถาปัตยกรรมระบบและวิศวกรรมฮาร์ดแวร์ระดับสากล',
    'about.ceo_role': 'กรรมการผู้จัดการ & ประธานเจ้าหน้าที่บริหาร (Managing Director & CEO)',
    'about.ceo_bio': 'กำกับดูแลทิศทางองค์กร ความเป็นเลิศในการบริหาร ความสัมพันธ์ลูกค้า และการขยายธุรกิจของ MSGTech ในภาคธุรกิจบริการและองค์กรชั้นนำทั่วประเทศไทย',
    'about.cto_role': 'หัวหน้าฝ่ายเทคโนโลยีและสถาปัตยกรรมระบบ (Head of Technology)',
    'about.cto_bio': 'เป็นผู้นำทีมวิศวกรรมหลัก การออกแบบสถาปัตยกรรมโซลูชัน ระบบคลาวด์ เครื่อง POS แคชเชียร์ ตู้คีออสบริการตัวเอง และการพัฒนาซอฟต์แวร์เฉพาะทางสำหรับลูกค้า',

    // ─── Capabilities & Contact Section ───
    'contact.subtitle': 'พันธมิตรเทคโนโลยีแบบครบวงจร',
    'contact.title': 'นัดหมายปรึกษาผู้เชี่ยวชาญ',
    'contact.desc': 'ครบวงจรตั้งแต่ฮาร์ดแวร์จนถึงซอฟต์แวร์ — หากคุณคิดได้ เราทำได้จริง ปรึกษาโครงการใหม่ การอัปเกรดกลอนโรงแรม ระบบ ERP หรือการติดตั้ง POS & คีออสกับทีมงานเรา',
    'contact.cap_enterprise_title': 'องค์กรและการปฏิบัติการ',
    'contact.cap_enterprise_1': 'ระบบ ERP องค์กรและบัญชีแยกประเภท',
    'contact.cap_enterprise_2': 'ระบบคลังสินค้าและสต็อกอัจฉริยะ',
    'contact.cap_enterprise_3': 'ระบบ HR และสแกนหน้า/ลายนิ้วมือคิดเงินเดือน',
    'contact.cap_enterprise_4': 'คำนวณต้นทุนสูตรอาหาร (BOM) และสั่งซื้ออัตโนมัติ',
    'contact.cap_enterprise_5': 'รวมงบการเงินและยอดขายหลายสาขา',

    'contact.cap_hospitality_title': 'โรงแรม บริการ และสปา',
    'contact.cap_hospitality_1': 'กลอนประตูดิจิทัลโรงแรม (Bluetooth & RFID)',
    'contact.cap_hospitality_2': 'ระบบจองคิวสปาและทรีตเมนต์หลายห้อง',
    'contact.cap_hospitality_3': 'ระบบ IoT ควบคุมในห้องพัก (แอร์, ไฟ, ผ้าม่าน)',
    'contact.cap_hospitality_4': 'ระบบจัดการห้องพัก OTA (2-Way Channel Manager)',
    'contact.cap_hospitality_5': 'เชื่อมโยงระบบบริหารโรงแรม (PMS) และบิล Folio',

    'contact.cap_pos_title': 'ระบบ POS และการค้าอัจฉริยะ',
    'contact.cap_pos_1': 'ระบบเครื่องชั่งคิดเงินร้านหมาล่ายอดนิยม',
    'contact.cap_pos_2': 'เครื่อง POS แคชเชียร์จอคู่เกรดพานิชย์',
    'contact.cap_pos_3': 'ตู้คีออสสั่งอาหารอัตโนมัติตั้งพื้นและเคาน์เตอร์',
    'contact.cap_pos_4': 'จอแสดงออเดอร์ในครัว (KDS) & บาร์โค้ดสลิป',
    'contact.cap_pos_5': 'ระบบรับเงินไร้เงินสด Thai PromptPay QR & EDC',

    'contact.cap_infra_title': 'โครงข่ายและวิศวกรรมเฉพาะทาง',
    'contact.cap_infra_1': 'เครือข่าย Wi-Fi 6/7 ความหนาแน่นสูง & สายไฟเบอร์',
    'contact.cap_infra_2': 'กล้องวงจรปิด AI สแกนใบหน้า และประตูกั้นอัตโนมัติ',
    'contact.cap_infra_3': 'พัฒนาแอป iOS & Android และพอร์ทัลพนักงาน',
    'contact.cap_infra_4': 'ปรับแต่งฮาร์ดแวร์และเฟิร์มแวร์เฉพาะธุรกิจ',
    'contact.cap_infra_5': 'หากคุณคิดได้ เราทำได้จริง!',

    'contact.direct_channels': 'ช่องทางติดต่อโดยตรง',
    'contact.info_exec': 'อีเมลติดต่อ',
    'contact.info_email': 'อีเมลติดต่อ',
    'contact.info_phone': 'เบอร์โทรศัพท์',
    'contact.info_hours': 'เวลาทำการ',
    'contact.info_hours_val': 'จันทร์ – ศุกร์: 09:00 – 18:00 น. (GMT+7)<br/>ดูแลลูกค้ารายสัญญา SLA ตลอด 24/7',
    'contact.info_hq': 'สำนักงานใหญ่',
    'contact.info_hq_val': 'เกาะสมุย<br/>13/1 หมู่ 1 ต.บ่อผุด อ.เกาะสมุย จ.สุราษฎร์ธานี 84320',
    'contact.deploy_note': '💡 <strong>บริการติดตั้งและดูแลหน้างานทั่วประเทศไทย:</strong> ตั้งแต่เกาะสมุย ภูเก็ต และกระบี่ จนถึงกรุงเทพฯ พัทยา และเชียงใหม่ — เราให้บริการส่งมอบฮาร์ดแวร์ถึงสถานที่ เดินสายสัญญาณระบบ เทรนนิ่งพนักงาน และดูแลบำรุงรักษาตามสัญญา SLA 24/7 อย่างต่อเนื่อง',

    'contact.form_card_title': 'เริ่มต้นการปรึกษา',
    'contact.form_card_sub': 'เลือกประเภทเทคโนโลยีที่ต้องการ เพื่อรับข้อเสนอสถาปัตยกรรม รายละเอียดฮาร์ดแวร์ หรือใบเสนอราคาภายใน 24 ชั่วโมง',
    'contact.form_primary_label': 'ประเภทเทคโนโลยีหลักที่ต้องการ',
    'contact.btn_open_modal': 'เปิดแบบฟอร์มนัดหมายปรึกษาโครงการ',
  },

  en: {
    // ─── Header & Navigation ───
    'nav.solutions': 'Solutions',
    'nav.mala_pos': 'Mala Scale POS',
    'nav.hardware': 'POS & Kiosks',
    'nav.leadership': 'Leadership',
    'nav.contact': 'Contact',
    'nav.book_consultation': 'Book Consultation',
    'nav.lang_toggle_label': 'Language / ภาษา: English (EN)',
    'nav.lang_display': 'EN',

    // ─── Hero Section ───
    'hero.badge': 'Thailand Hospitality & Enterprise Technology',
    'hero.title': 'Elevating Thailand\'s Hospitality & Commerce With Intelligent Systems',
    'hero.desc': 'Bespoke engineering for high-traffic restaurants, luxury island resorts, and modern enterprises. Headquartered in Koh Samui, powering businesses across Surat Thani, Bangkok, and nationwide.',
    'hero.btn_solutions': 'Explore Solutions',
    'hero.btn_mala_sim': 'Test Mala Scale Simulator',
    'hero.stat_latency_val': 'Sub-10ms',
    'hero.stat_latency_label': 'Scale POS Latency',
    'hero.stat_uptime_val': '99.98%',
    'hero.stat_uptime_label': 'Enterprise SLA Uptime',
    'hero.stat_terminals_val': '150+',
    'hero.stat_terminals_label': 'Commercial Terminals',
    'hero.stat_margin_val': '0%',
    'hero.stat_margin_label': 'Hardware Margin-Of-Error',

    // ─── Architecture & Deconstruct ───
    'arch.subtitle': 'Unified Architectural Core',
    'arch.title': 'Engineered For Zero Latency & Zero Shrinkage',
    'arch.desc': 'Why legacy disconnected POS setups leak revenue and how MSGTech unified systems solve it.',
    'arch.tab_comparison': 'System Comparison',
    'arch.tab_legacy': 'Deconstruct Legacy POS',
    'arch.tab_msgtech': 'MSGTech Reconstructed Architecture',

    'arch.legacy_badge': 'Legacy Fragmented POS',
    'arch.legacy_title': 'Disjointed Hardware & Manual Entry Bottlenecks',
    'arch.legacy_desc': 'Traditional food and retail operations rely on detached scale displays, manual entry clerks, and unsynchronized receipt printers. Every manual step costs time and introduces margin leakage.',
    'arch.legacy_p1': 'Staff manually re-types weight into POS, creating human error & slow checkout',
    'arch.legacy_p2': 'Separate thermal receipt printer stutters on high volume shifts',
    'arch.legacy_p3': 'Inventory is not deducted live, causing 8-12% unaccounted recipe shrinkage',
    'arch.legacy_p4': 'Cloud-only dependency means internet drops completely freeze front counter',
    'arch.legacy_tag1': 'Manual Entry',
    'arch.legacy_tag2': 'Slow Turnaround',
    'arch.legacy_tag3': 'Inventory Leakage',
    'arch.legacy_tag4': 'Lost Revenue',

    'arch.unified_badge': 'MSGTech Unified Architecture',
    'arch.unified_title': 'Sub-Millisecond Synchronized POS, Scale & KDS',
    'arch.unified_desc': 'A synchronized ecosystem: Direct RS-232 telemetry streams weight into POS core, auto-deducts bowl tare, generates dynamic Thai PromptPay QR, and prints kitchen barcodes in under 8 seconds.',
    'arch.unified_p1': 'Hardware-direct RS-232 scale feed updates in 10ms with zero manual clerk input',
    'arch.unified_p2': 'Automatic tare deduction calibrated for standard bowls and sensor stability check',
    'arch.unified_p3': 'Dynamic PromptPay QR generated instantly alongside thermal kitchen slip',
    'arch.unified_p4': 'Offline-first SQLite local caching ensures sales never halt when internet drops',
    'arch.unified_tag1': 'RS-232 Direct Stream',
    'arch.unified_tag2': 'Auto-Tare Calibration',
    'arch.unified_tag3': 'Under 8s Checkout',
    'arch.unified_tag4': '100% Accuracy',

    // ─── Mala Scale POS Simulator ───
    'mala.subtitle': 'Trade-Certified Scale Simulator',
    'mala.title': 'Interactive POS Scrollytelling Workbench',
    'mala.desc': 'Scroll down to experience the sub-millisecond digital weight streaming, tare deduction, live pricing counter, and automatic Thai PromptPay QR generation.',
    
    'mala.step0_btn': '🥣 1. Tare (0.0g)',
    'mala.step1_btn': '🥩 2. +Angus Beef (+140g)',
    'mala.step2_btn': '🥬 3. +Lotus & Enoki (+110g)',
    'mala.step3_btn': '🍢 4. +Meatballs (+125g)',
    'mala.step4_btn': '💳 5. Lock & PromptPay QR',
    'mala.autoplay_start': '▶ Auto-Play Demo',
    'mala.autoplay_pause': '⏸ Pause Demo',

    'mala.console_title': '⚖️ Digital Scale Weight Dialog',
    'mala.console_baud': 'RS-232 COM2 • 9600 BAUD • 10ms REFRESH',
    'mala.status_streaming': '● STREAMING (10ms)',
    'mala.status_stabilized': '● STABILIZED (LOCKED)',
    'mala.live_net_weight': 'LIVE NET WEIGHT',
    'mala.gross_label': 'GROSS:',
    'mala.tare_label': 'TARE:',
    'mala.net_label': 'NET:',

    'mala.platter_label': 'MSGTECH TRADE-CERTIFIED SCALE PLATTER',
    'mala.bowl_title': '🥣 Mala Ingredient Bowl',
    'mala.bowl_empty_title': '🥣 Empty Bowl Ready',
    'mala.bowl_empty_sub': 'Auto-Tare Calibrated (-120.0g) • Awaiting items',

    'mala.slider_label': 'Manual Weight Load Slider',
    'mala.slider_range': '120g – 950g',
    'mala.tray_header': 'Or Tap Ingredients to Test:',
    'mala.tray_beef': '🥩 Angus Beef (+140g)',
    'mala.tray_veg': '🥬 Enoki & Lotus (+110g)',
    'mala.tray_balls': '🍢 Fish Tofu & Balls (+125g)',
    'mala.tray_mushroom': '🍄 Shiitake Mix (+75g)',

    'mala.broth_header': 'Select Mala Broth & Spice:',
    'mala.broth_dry': '🔥 Stir-Fry (Medium)',
    'mala.broth_soup': '🌶️ Mala Soup (Extra)',
    'mala.broth_bone': '🍲 Collagen Broth',
    'mala.broth_tomato': '🍅 Tomato Herbal',

    'mala.customer_screen_badge': 'Customer-Facing Screen (Live Mirror)',
    'mala.order_total_label': 'Order Total',
    'mala.cust_net_label': 'Net Weight:',
    'mala.cust_rate_label': 'Unit Rate:',
    'mala.cust_broth_label': 'Broth Selection:',

    'mala.qr_awaiting_title': 'Awaiting Weight Stabilization...',
    'mala.qr_awaiting_sub': 'Place ingredients to generate dynamic QR.',
    'mala.qr_active_title': '✓ PromptPay QR Active',
    'mala.qr_active_sub': 'Scan with any Thai mobile banking app to pay',

    'mala.ticket_shop': 'MSGTECH MALA HOTPOT KITCHEN',
    'mala.ticket_table': 'Order #M108 • Table 14',
    'mala.ticket_item': 'Custom Mala Bowl',
    'mala.ticket_total': 'Total Amount',
    'mala.ticket_kds': 'KDS Barcode: ML-8924108',

    // ─── Solutions Suite ───
    'solutions.subtitle': 'Tailored For Performance',
    'solutions.title': 'Comprehensive Technology Stack',
    'solutions.desc': 'Modular, reliable technology systems designed to streamline daily operations, delight guests, and accelerate business growth.',
    'solutions.tab_all': 'All Solutions',
    'solutions.tab_enterprise': 'Enterprise Systems',
    'solutions.tab_hotel': 'Hospitality & Wellness',
    'solutions.tab_pos': 'POS & Kiosks',
    'solutions.tab_infra': 'Infrastructure & Security',
    'solutions.tab_custom': 'Custom Engineering',

    // ─── Hardware Showcase ───
    'hardware.subtitle': 'Commercial Grade Hardware',
    'hardware.title': 'Built For Demanding Environments',
    'hardware.desc': 'Industrial-grade POS terminals, high-brightness guest kiosks, waterproof scale assemblies, and hospitality door locks engineered for island humidity and heavy daily throughput.',
    'hardware.pos_title': 'Dual-Screen Heavy Duty POS Terminal',
    'hardware.pos_desc': '15.6" capacitive touch primary display with integrated customer-facing mirror. Fanless aluminum cast chassis built for round-the-clock kitchen heat and humidity.',
    'hardware.kiosk_title': 'Self-Ordering Interactive Kiosks (21.5" & 27")',
    'hardware.kiosk_desc': 'Floor and counter self-service kiosks with integrated QR scanner, 80mm auto-cut receipt printer, and Thai banking QR payment ready out-of-the-box.',
    'hardware.scale_title': 'Trade-Certified Weighing Scale Assembly',
    'hardware.scale_desc': 'SUS304 food-grade stainless steel platter with hermetically sealed IP67 load cell. Native RS-232/USB serial connection directly streamable to POS core.',
    'hardware.locks_title': 'Smart Hotel Locks & Bluetooth/RFID Access',
    'hardware.locks_desc': 'Commercial grade marine-resistant door locks with Mifare RFID card support, guest mobile Bluetooth keys, and real-time integration into hotel PMS systems.',
    'hardware.printer_title': 'High-Speed 260mm/s Thermal Kitchen Printers',
    'hardware.printer_desc': 'Heavy-duty commercial kitchen ticket printers with auto-cutter, loud buzzer alert for noisy hotpot kitchens, and multi-interface LAN/USB/Serial.',
    'hardware.wifi_title': 'Enterprise Wi-Fi 7 & Fiber Network Infrastructure',
    'hardware.wifi_desc': 'High-density indoor/outdoor access points, managed PoE switches, and rack server installations supporting thousands of concurrent guest devices.',

    // ─── Leadership & Local Team ───
    'leadership.subtitle': 'Island-Born, Nationally Trusted',
    'leadership.title': 'Leadership & Technical Expertise',
    'leadership.desc': 'Headquartered on Koh Samui with rapid onsite engineering response teams across Koh Phangan, Surat Thani, Bangkok, and Chiang Mai.',
    'leadership.nick_role': 'Founder & Chief Architect',
    'leadership.nick_bio': 'Specialist in enterprise cloud architecture, embedded hardware integration, and POS systems. Brings international software engineering background to elevate luxury hospitality and dining across Koh Samui and Thailand.',
    'leadership.co_role': 'Senior Engineering & Infrastructure Team',
    'leadership.co_desc': 'Dedicated engineers specializing in IoT hardware prototyping, fiber network deployment, and high-availability enterprise database integrations.',
    
    'leadership.pillar1_title': '2-Hour On-Island Emergency Response',
    'leadership.pillar1_desc': 'Rapid local technical assistance on Koh Samui and Koh Phangan. No waiting days for support teams to fly from Bangkok.',
    'leadership.pillar2_title': 'Marine Climate & Humidity Hardened',
    'leadership.pillar2_desc': 'All deployed hardware and terminals are rigorously selected and treated to withstand high humidity, coastal salinity, and power fluctuations.',
    'leadership.pillar3_title': 'Direct Architect & Developer Access',
    'leadership.pillar3_desc': 'Work directly with the software architects and hardware engineers who build your systems, ensuring precise customization and zero middlemen.',
    'leadership.pillar4_title': 'Zero-Fee Technical Assessment & Blueprint',
    'leadership.pillar4_desc': 'Complimentary onsite survey and technical blueprint consultation to audit your current workflow and propose optimized architecture.',

    // ─── Contact & Modal ───
    'modal.title': 'Schedule Consultation',
    'modal.desc': 'Connect directly with MSGTech leadership and solutions architects. Hardware to software — if you can think of it, we can do it.',
    'modal.name_label': 'Your Full Name / Company',
    'modal.name_placeholder': 'e.g. John Doe, Muang Samui Wellness Resort',
    'modal.email_label': 'Business Email Address',
    'modal.email_placeholder': 'e.g. contact@yourbusiness.com or nick@msgtech.co.th',
    'modal.service_label': 'Required Technology Solution',
    'modal.service_default': '-- Select Solution Area --',
    'modal.service_general': 'General Architecture & Consultation',
    'modal.service_mala': 'Trade-Scale Integrated Mala POS',
    'modal.service_pos': 'Cashier POS & Self-Checkout Kiosks',
    'modal.service_erp': 'Enterprise ERP & Financial Systems',
    'modal.service_inventory': 'Smart Inventory & Warehouse Management',
    'modal.service_hotel': 'Smart Hotel IoT & Door Locks',
    'modal.service_spa': 'Spa & Wellness Management System',
    'modal.service_channel': 'Channel Manager & Booking Engines',
    'modal.service_wifi': 'Network Infrastructure & Enterprise Wi-Fi',
    'modal.service_cctv': 'CCTV, AI Surveillance & Access Control',
    'modal.service_custom': 'Turnkey Custom IT & Hardware Engineering',

    'modal.scope_label': 'Click Scope Tags to Include:',
    'modal.chip_erp': 'ERP Systems',
    'modal.chip_inventory': 'Smart Inventory',
    'modal.chip_hr': 'HR & Payroll',
    'modal.chip_hotel_locks': 'Smart Hotel Locks',
    'modal.chip_spa': 'Spa Booking',
    'modal.chip_mala': 'Mala Scale POS',
    'modal.chip_pos': 'Cashier POS',
    'modal.chip_kiosk': 'Self-Checkout Kiosks',
    'modal.chip_wifi': 'Enterprise Wi-Fi',
    'modal.chip_cctv': 'CCTV & Security',
    'modal.chip_app': 'Custom Mobile App',
    'modal.chip_hardware': 'Custom Hardware',
    'modal.msg_label': 'Project Scope & Requirements',
    'modal.msg_placeholder': 'Tell us about your requirements, branch count, timeline, or hardware needs...',
    'modal.submit_btn': 'Submit Request to MSGTech',
    'modal.success_title': '✓ Email Draft Prepared',
    'modal.success_sub': 'Your email draft to info@msgtech.co.th has been prepared. Our leadership team will respond within 24 hours.',

    // ─── Footer ───
    'footer.company_desc': 'Premier technology provider and IT solutions partner headquartered in Koh Samui, powering luxury hospitality, restaurants, and modern enterprises across Thailand.',
    'footer.col_solutions': 'Solutions',
    'footer.col_company': 'Company',
    'footer.col_regions': 'Service Areas',
    'footer.col_contact': 'Get in Touch',
    'footer.col_inquiries': 'Direct Inquiries',
    'footer.inquiries_sub': 'Speak directly with our team for enterprise and hospitality proposals.',
    'footer.reg_samui': 'Koh Samui (HQ)',
    'footer.reg_phangan': 'Koh Phangan',
    'footer.reg_surat': 'Surat Thani',
    'footer.reg_bkk': 'Bangkok',
    'footer.reg_cm': 'Chiang Mai & Nationwide',
    'footer.address_val': '13/1 Bo Put, Ko Samui District, Surat Thani 84320, Thailand',
    'footer.phone_val': '081-894-5556',
    'footer.email_val': 'info@msgtech.co.th',
    'footer.rights': '© 2026 MSGTech Co., Ltd. All rights reserved.',
    'footer.bottom_loc': 'Koh Samui Island, Surat Thani, Thailand • Hospitality Technology & Cashier POS Systems',
    'footer.certified': 'Hardware and weighing assemblies comply with Thailand trade measurement standards and Department of Internal Trade certifications.',

    // ─── Mala POS Deconstruct & Benchmark Extra ───
    'arch.benchmark': '🍜 High-Volume F&B Engineering Benchmark',
    'arch.section_title': 'Deconstructing The Traditional POS & Reconstructing For Mala Restaurants',
    'arch.section_desc': 'Mala Tang and Hotpot restaurants face a critical bottleneck: prices rely on bowl weight. Conventional POS setups force cashiers to eyeball weights, manually type numbers, and decipher handwritten slips. Here is how MSGTech deconstructs the problem and reconstructs it with trade-approved scale integration.',
    'arch.toggle_comparison': 'Architectural Comparison',
    'arch.toggle_deconstruct': 'Legacy Breakdown (4 Flaws)',
    'arch.toggle_reconstruct': 'MSGTech Unified Architecture',
    'arch.legacy_badge_flaw': '⚠️ Deconstructed: Previous Normal POS',
    'arch.legacy_tag_time': '45–60s Per Guest Bottleneck',
    'arch.legacy_h3': 'Why Normal POS Breaks in Mala Restaurants',
    'arch.legacy_sub': 'Standard POS setups treat weight as an afterthought, creating huge margins of human error and inventory shrinkage.',
    'arch.flaw1_title': 'Disconnected Standalone Scale:',
    'arch.flaw1_desc': 'The scale is a dumb separate unit with no cable or communication to the POS. Cashier must eyeball LED numbers.',
    'arch.flaw2_title': 'Manual Keypad Grams Entry:',
    'arch.flaw2_desc': 'Cashier enters grams by hand onto the touchscreen. Frequent typing mistakes, intentional shrinkage, and queue delays.',
    'arch.flaw3_title': 'Inconsistent Bowl Tare:',
    'arch.flaw3_desc': 'Bowl weights vary (ceramic vs melamine vs stainless). Manual tare is frequently skipped, triggering guest disputes.',
    'arch.flaw4_title': 'Handwritten Slips & Mix-Ups:',
    'arch.flaw4_desc': 'Soup broth and spice levels written on paper slips or stickers. Kitchen misinterprets handwriting, leading to remakes.',

    'arch.recon_badge': '✨ Reconstructed: MSGTech Trade-Scale POS',
    'arch.recon_speed': '< 8s Queue Speed',
    'arch.recon_h3': 'Coupled Digital Scale + Dual-Screen Flow',
    'arch.recon_sub': 'A unified hardware-software architecture with sub-millisecond digital scale feed, automated tare, and instant PromptPay QR.',
    'arch.recon1_title': 'Trade-Certified RS-232 / USB Protocol:',
    'arch.recon1_desc': 'Weight scale directly streams raw digital weight packets to the POS application every 10ms with zero manual input.',
    'arch.recon2_title': 'Automatic Smart Bowl Tare:',
    'arch.recon2_desc': 'Bowl placed on plate auto-deducts tare weight (-120.0g) instantly. Only net ingredients are billed.',
    'arch.recon3_title': 'Live Customer-Facing Price Mirror:',
    'arch.recon3_desc': 'Customer screen displays grams, rate per 100g, and total price in real time as ingredients settle.',
    'arch.recon4_title': '1-Tap Broth Matrix & Barcode Ticket:',
    'arch.recon4_desc': '1-tap broth selection generates Thai PromptPay QR in under 1s and prints 80mm barcode ticket for kitchen KDS tracking.',

    // ─── Mala Simulator Workbench Extra ───
    'mala.testbench_badge': 'Interactive Test Bench',
    'mala.testbench_title': 'Live Scale POS Interactive Simulator',
    'mala.testbench_desc': 'Adjust tray weights, toggle auto-tare, select spicy broths, and watch the dual-screen POS and thermal kitchen printer react live.',
    'mala.tare_badge': 'TARE: AUTO (-120g)',
    'mala.btn_zero_tare': 'Zero Tare (Calibrate)',
    'mala.step_init_text': 'Step 1/5: Empty Bowl Placed & Auto-Tare Calibrated (-120.0g)',
    'mala.sys_listening_title': 'System Listening to Scale Stream...',
    'mala.sys_listening_desc': 'Scroll down to drop ingredients onto the scale. System notices amount and recalculates in real-time.',

    // ─── Hardware Extra ───
    'hardware.section_subtitle': 'Hardware & Systems',
    'hardware.section_title': 'Cashier POS & Self-Checkout Kiosks',
    'hardware.section_desc': 'Commercial-grade POS terminals, intuitive self-checkout kiosks, and reliable hospitality peripherals with seamless Thai QR / PromptPay & card payments.',
    'hardware.badge_cashier': 'Cashier Station',
    'hardware.card1_title': 'Cashier POS',
    'hardware.card1_desc': 'Fast, responsive dual-screen cashier terminals featuring an interactive customer-facing display, built-in thermal receipt printing, and automated cash drawer triggers.',
    'hardware.card1_tag1': 'Dual Touch Screen',
    'hardware.card1_tag2': 'Fast Thermal Printing',
    'hardware.card1_tag3': 'PromptPay QR',

    'hardware.badge_kiosk': 'Express Service',
    'hardware.card2_title': 'Self-Checkout Kiosks',
    'hardware.card2_desc': 'Sleek freestanding and countertop self-ordering kiosks designed for hotels, quick-serve dining, and retail checkout with barcode scanning and cashless payment integration.',
    'hardware.card2_tag1': 'Self-Ordering',
    'hardware.card2_tag2': 'Barcode Scanner',
    'hardware.card2_tag3': 'Credit Card & QR',

    'hardware.badge_peripherals': 'Connected Devices',
    'hardware.card3_title': 'Hospitality & Retail Peripherals',
    'hardware.card3_desc': 'Certified peripheral integrations for trade-approved weighing scales, digital kitchen displays (KDS), room keycard locks, and smart environmental sensors.',
    'hardware.card3_tag1': 'Trade Weighing Scales',
    'hardware.card3_tag2': 'Kitchen KDS',
    'hardware.card3_tag3': 'RFID Keycards',

    // ─── Leadership Section ───
    'about.subtitle': 'Our Leadership',
    'about.title': 'Experienced & Dedicated Leadership',
    'about.desc': 'Guided by executive vision in Thailand\'s hospitality market and backed by strong technical leadership in systems architecture and hardware engineering.',
    'about.ceo_role': 'Managing Director & CEO',
    'about.ceo_bio': 'Directing MSGTech\'s corporate strategy, executive leadership, client relations, and strategic business growth across Thailand\'s premier hospitality and enterprise sectors.',
    'about.cto_role': 'Head of Technology',
    'about.cto_bio': 'Leading the core engineering organization, solution architecture, cloud infrastructure, cashier POS systems, self-checkout kiosks, and custom client software delivery.',

    // ─── Capabilities & Contact Section ───
    'contact.subtitle': 'All-In-One Technology Partner',
    'contact.title': 'Schedule A Consultation',
    'contact.desc': 'Everything from hardware to software — if you can think of it, we can do it. Discuss your upcoming project, hotel lock upgrade, ERP migration, or cashier POS & kiosk deployment with our team.',
    'contact.cap_enterprise_title': 'Enterprise & Operations',
    'contact.cap_enterprise_1': 'Enterprise ERP & Financial Ledgers',
    'contact.cap_enterprise_2': 'Smart Warehouse & Inventory Systems',
    'contact.cap_enterprise_3': 'HR & Biometric Facial/Fingerprint Payroll',
    'contact.cap_enterprise_4': 'BOM Recipe Costing & Auto Reordering',
    'contact.cap_enterprise_5': 'Multi-Branch Financial Consolidation',

    'contact.cap_hospitality_title': 'Hospitality & Wellness',
    'contact.cap_hospitality_1': 'Smart Hotel Locks (Bluetooth & RFID Keycards)',
    'contact.cap_hospitality_2': 'Spa & Wellness Multi-Room Booking Systems',
    'contact.cap_hospitality_3': 'In-Room Environmental IoT (AC, Lighting, Curtains)',
    'contact.cap_hospitality_4': '2-Way SaaS Channel Manager & Booking Engines',
    'contact.cap_hospitality_5': 'Hotel PMS Deep Folio Billing Integrations',

    'contact.cap_pos_title': 'POS & Smart Retail Tech',
    'contact.cap_pos_1': 'Trade-Scale Integrated Mala POS Systems',
    'contact.cap_pos_2': 'Dual-Screen Commercial Cashier POS',
    'contact.cap_pos_3': 'Freestanding & Countertop Self-Checkout Kiosks',
    'contact.cap_pos_4': 'Kitchen Display Systems (KDS) & Barcode Printing',
    'contact.cap_pos_5': 'Cashless Thai PromptPay QR & EDC Terminals',

    'contact.cap_infra_title': 'Infrastructure & Custom IT',
    'contact.cap_infra_1': 'High-Density Enterprise Wi-Fi 6/7 & Fiber Cabling',
    'contact.cap_infra_2': 'Commercial CCTV, AI Surveillance & Turnstiles',
    'contact.cap_infra_3': 'Custom iOS & Android Apps & Staff Portals',
    'contact.cap_infra_4': 'Tailor-Made Hardware & Firmware Modifications',
    'contact.cap_infra_5': 'If you can think of it, we can do it!',

    'contact.direct_channels': 'Direct Channels',
    'contact.info_exec': 'Contact Email',
    'contact.info_email': 'Contact Email',
    'contact.info_phone': 'Phone',
    'contact.info_hours': 'Service Hours',
    'contact.info_hours_val': 'Monday – Friday: 09:00 – 18:00 (GMT+7)<br/>24/7 Priority Support for SLA Clients',
    'contact.info_hq': 'Headquarters',
    'contact.info_hq_val': 'Koh Samui Island<br/>13/1 Tambon Bo Put, Ko Samui District, Surat Thani 84320',
    'contact.deploy_note': '💡 <strong>On-Site Deployments Across Thailand:</strong> From Koh Samui, Phuket, and Krabi to Bangkok, Pattaya, and Chiang Mai — we provide complete on-site hardware delivery, structured cabling, staff training, and ongoing 24/7 SLA maintenance.',

    'contact.form_card_title': 'Start a Conversation',
    'contact.form_card_sub': 'Select your technology requirement to receive an architectural scope, hardware breakdown, or quotation within 24 hours.',
    'contact.form_primary_label': 'Primary Technology Requirement',
    'contact.btn_open_modal': 'Open Project Consultation Form',
  }
};
